<template>
  <b-container>
    <b-row class="ml-2">
      <h4>Notificações de vencimento do agendamento</h4>
      <b-table-simple hover small caption-top responsive>
        <b-thead>
          <b-tr>
            <b-th v-for="field in notifyFields" :key="field.key">
              {{ field.label }}
            </b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <template v-for="row in fillActiveList">
            <!-- {{ row }} -->
            <b-tr>
              <b-td>
                <base-input-integer
                  id="dueDateIntervalRange"
                  placeholder="Insira em quanto tempo irá vencer"
                  :value.sync="row.item.notifyIntervalRange"
                  :readonly="false"
                  title="Em quanto tempo irá enviar a notificação"
                  v-b-tooltip.hover
                >
                </base-input-integer>
              </b-td>
              <b-td>
                <b-form-select
                  class="select-field"
                  :options="optionsIntervalType"
                  v-model="row.item.notifyIntervalType"
                ></b-form-select>
              </b-td>
              <b-td>
                <b-form-select
                  class="select-field"
                  :options="optionsNotify"
                  v-model="row.item.notificationType"
                ></b-form-select>
              </b-td>
              <b-td style="min-width: 10px">
                <b-button
                  class="ml-1"
                  size="sm"
                  :title="$t('checklist.form.fieldDelete')"
                  v-b-tooltip.hover
                  @click="deleteField(row)"
                >
                  X
                </b-button>
              </b-td>
            </b-tr>
          </template>
        </b-tbody>
      </b-table-simple>
    </b-row>
    <!-- {{ items }} -->
    <b-button size="sm" @click="addNotify">
      {{ $t("checklist.pendencies.addNotification") }}
    </b-button>
  </b-container>
</template>
<script>
export default {
  name: "SchedulerNotify",
  components: {
    BaseInputInteger: () =>
      import("@/components_rms/base/BaseInputInteger.vue"),
  },
  props: {
    items: Array,
  },
  computed: {
    fillActiveList() {
      let camposAtivos = [];
      for (let campo of this.tableRows) {
        console.log("campo");
        console.log(campo);
        if (campo.item.active) {
          camposAtivos.push(campo);
        }
      }
      return camposAtivos;
    },
  },
  data() {
    return {
      tableRows: [],
      notifyFields: [
        {
          label: "Tempo",
          key: "notifyIntervalRange",
          sortable: false,
        },
        {
          label: "Frequência",
          key: "notifyIntervalType",
          sortable: false,
        },
        {
          label: this.$t("checklist.pendencies.typeNotification"),
          key: "notificationType",
          sortable: false,
        },
        {
          label: "",
          key: "actions",
          sortable: false,
        },
      ],
      optionsIntervalType: [
        { value: 1, text: "Hora" },
        { value: 2, text: "Dia" },
        { value: 3, text: "Semana" },
        { value: 4, text: "Mês" },
        { value: 5, text: "Ano" },
      ],
      optionsNotify: [{ value: 0, text: "E-mail" }],
    };
  },
  mounted: function () {
    this.loadTableRows();
  },
  methods: {
    addTableRow(item) {
      this.tableRows.push({
        configShowing: false,
        detailsShowing: false,
        item: item,
      });
    },
    loadTableRows() {
      this.tableRows = [];
      if (this.items) {
        if (this.items.length > 0) {
          this.items.forEach((item) => {
            this.addTableRow(item);
          });
        }
      }
      this.$forceUpdate();
    },
    addNotify() {
      let item = {
        active: true,
        notificationType: 0,
        notifyIntervalType: 1,
        notifyIntervalRange: 0,
        message: "",
      };
      this.items.push(item);
      this.addTableRow(item);
      this.$forceUpdate();
    },
    getPendencyDueDateIntervalRangeLabel(item) {
      let text = this.$t("checklist.pendencies.timeToDueDate");
      if (item) {
        switch (item) {
          case 1:
            return `${text} (Horas)`;
          case 2:
            return `${text} (Dias)`;
          case 3:
            return `${text} (Semanas)`;
          case 4:
            return `${text} (Meses)`;
          case 5:
            return `${text} (Anos)`;
          default:
            return text;
        }
      }
      return text;
    },
    deleteField(row) {
      if (!row.item.id || row.item.id == 0) {
        let rowIndex = this.tableRows.indexOf(row);
        if (rowIndex >= 0) {
          this.tableRows.splice(rowIndex, 1);
        }

        let itemIndex = this.items.indexOf(row.item);
        if (itemIndex >= 0) {
          this.items.splice(itemIndex, 1);
        }
      } else {
        row.item.active = false;
      }
    },
  },
};
</script>
